/*
    Developer Name :  RAJA
    Developed Date :  03-12-2021
    Page Name      :  Item Storage Shelf Service
    Created        :  03-12-2021
    Last Edited By : 
    Edited Date    : 
    Last Edited    : 
*/
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ItemStorageShelfApi} from '../../api/master/item-storage-shelf-mst.api';
import { switchMap, map } from 'rxjs/operators';
import { ItemStorageShelfData,ItemStorageShelf  } from '../../interface/master/item-storage-shelf-mst';

@Injectable()
export class ItemStorageShelfService extends ItemStorageShelfData {

  constructor(private api: ItemStorageShelfApi) {
    super();
  }


  list(url: string): Observable<ItemStorageShelf[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<ItemStorageShelf>{
      return this.api.getById(url);
  }

  create(url: string, data:ItemStorageShelf): Observable<ItemStorageShelf> {
    return this.api.add(url,data);
  }

  update(url: string, data:ItemStorageShelf): Observable<ItemStorageShelf> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
